export default "__VITE_ASSET__BIhUUx8Z__"